export default "__VITE_ASSET__Ded$HOMT__"